import {createSelector} from '@ngrx/store';
import {SharedLinkState} from './shared-link.model';

export const sharedLinkFeatureKey = 'sharedLink';

interface AppState {
  [sharedLinkFeatureKey]: SharedLinkState;
}

export const selectSharedLinkState = (state: AppState): SharedLinkState => state[sharedLinkFeatureKey];
export const selectSharedLinkId = createSelector(
  selectSharedLinkState,
  (state: SharedLinkState) => state.sharedLinkId,
);
export const selectSharedLinkData = createSelector(
  selectSharedLinkState,
  (state: SharedLinkState) => state.sharedLinkData,
);
export const selectIsPreviewMode = createSelector(
  selectSharedLinkState,
  (state: SharedLinkState) => state.isPreviewMode,
);
